var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlignLefticon = function SvgAlignLefticon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.222 9.535H2.556V7.979h7c.43 0 .777-.348.777-.777V4.09a.778.778 0 0 0-.777-.778h-7V2.146a.389.389 0 0 0-.39-.389H1.39a.389.389 0 0 0-.389.39v13.221c0 .215.174.39.389.39h.778a.389.389 0 0 0 .389-.39v-1.166h11.666c.43 0 .778-.349.778-.778v-3.111a.778.778 0 0 0-.778-.778ZM8.778 4.868v1.556H2.556V4.868h6.222Zm4.666 7.778V11.09H2.556v1.556h10.888Z",
    clipRule: "evenodd"
  })));
};
export default SvgAlignLefticon;